import Text from 'components/commons/Text';
import LocalizeInput from 'components/input/LocalizeInput';
import { InnerGroup } from 'components/layouts/CommonForm';
import { InnerSection } from 'components/layouts/CommonForm';
import React, { useEffect } from 'react';
import { Button, Row, useModelStateContext } from 'saladsoft-primitive';
import LocalizeEditor from 'components/input/LocalizeEditor';
import UploadButton from 'components/input/UploadButton';
import { AdminLandmarkDto, AdminLandmarkRequestDto } from 'services/data-contracts';
import ServiceHelper from 'stores/ServiceHelper';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import { useStoreWrapper } from 'stores/StoreHelper';
import IconButton from 'controls/IconButton';

const NewLandmarkModal = ({ landmark }: { landmark?: AdminLandmarkDto }) => {
  const { uiStore } = useStoreWrapper();
  const { stateModel, setState, setMultipleState, serviceModel, unmountModel } =
    useModelStateContext<AdminLandmarkDto>();

  const [image, setImage] = React.useState<File | null>(null);

  const deleteImages = async () => {
    if (landmark?.images && landmark.images.length > 0) {
      const deletePromises = landmark.images.map((image) =>
        ServiceHelper?.adminLandmarkService?.deleteLandmarkImage(
          landmark.id as number,
          image.id as number,
        ),
      );
      await Promise.all(deletePromises);
    }
    return;
  };

  const handleClickCreate = () => {
    if (landmark?.id) {
      ServiceHelper?.adminLandmarkService
        ?.updateLandmark(landmark?.id, serviceModel.current as AdminLandmarkRequestDto)
        .then(async (res) => {
          if (res.status === 200) {
            const landmarkId = res.data.id;
            if (landmarkId && image) {
              await deleteImages();
              ServiceHelper?.adminLandmarkService
                ?.createLandmarkImage(landmarkId, { seq: 1 }, { file: image! })
                .then((res) => {
                  closeModal('장소 수정이 완료되었습니다.');
                  return;
                });
            } else {
              closeModal('장소 수정이 완료되었습니다.');
            }
          } else {
            toast.error('장소 수정에 실패하였습니다.');
          }
        });
    } else {
      if (stateModel) {
        ServiceHelper?.adminLandmarkService?.createLandmark(stateModel).then((res) => {
          if (res.status === 200) {
            const optionId = res.data.id;
            if (optionId && image) {
              ServiceHelper?.adminLandmarkService
                ?.createLandmarkImage(optionId, { seq: 1 }, { file: image! })
                .then((res) => {
                  closeModal('장소 생성이 완료되었습니다.');
                });
            } else {
              closeModal('장소 생성이 완료되었습니다.');
            }
          } else {
            toast.error('장소 생성에 실패하였습니다.');
          }
        });
      }
    }
  };

  const handleClickDelete = () => {
    if (landmark?.id) {
      uiStore?.confirm.show({
        title: '장소 삭제',
        message: '장소을 삭제하시겠습니까?',
        onConfirmed: () => {
          ServiceHelper?.adminLandmarkService
            ?.deleteLandmark(landmark?.id as number)
            .then((res) => {
              closeModal('장소 삭제가 완료되었습니다.');
            });
        },
      });
    }
  };

  const closeModal = (title: string) => {
    toast.success(title);
    uiStore?.modal.confirm();
  };

  useEffect(() => {
    if (landmark) {
      setMultipleState(landmark);
    }
    return () => {
      unmountModel();
    };
  }, [landmark]);


  return (
    <div>
      <InnerSection style={{ minHeight: '500px' }}>
        <InnerGroup>
          <div>
            <Text type="H3" style={{ marginBottom: 10 }}>
              장소명 등록
            </Text>
            <Text type="H4" buttonRole="DESCRIPTION">
              장소의 명칭을 입력하여 주세요.
            </Text>
            <div style={{ marginTop: 50 }}>
              <UploadButton
                onChange={(file) => {
                  setImage(file);
                }}
              >
                사진등록
              </UploadButton>
            </div>
          </div>
          <div>
            <LocalizeInput
              defaultValue={landmark?.localizedName}
              onChange={(value) => {
                setState('localizedName', value);
              }}
            />
          </div>
        </InnerGroup>
        <InnerGroup style={{ marginTop: 40 }}>
          <div>
            <Text type="H3" style={{ marginBottom: 10 }}>
              위치
            </Text>
            <Text type="H4" buttonRole="DESCRIPTION">
              장소의 위치를 등록 해주세요.
            </Text>
          </div>
          <div>
            <LocalizeInput
              defaultValue={landmark?.localizedAddress}
              onChange={(value) => {
                setState('localizedAddress', value);
              }}
            />
          </div>
        </InnerGroup>

        <InnerGroup style={{ marginTop: 40 }}>
          <div>
            <Text type="H3" style={{ marginBottom: 10 }}>
              장소정보 등록
            </Text>
            <Text type="H4" buttonRole="DESCRIPTION">
              장소의 상세 내용을 등록 해주세요.
            </Text>
          </div>
          <div>
            <LocalizeEditor
              defaultValue={landmark?.localizedDesc}
              onChange={(value) => {
                setState('localizedDesc', value);
              }}
            />
          </div>
        </InnerGroup>
        <ButtonGroupWrapper>
          <Row width="100%" justifyContent="space-between" alignItems="center">
            <Row gap={10} marginTop={40} justifyContent="flex-start">
              <Button
                type="outlined"
                onClick={() => {
                  uiStore?.modal.close();
                }}
              >
                생성 취소
              </Button>
              <Button onClick={handleClickCreate}>
                {landmark?.id ? '장소 수정하기' : '장소 생성하기'}
              </Button>
            </Row>
            <IconButton
              type="delete"
              onClick={() => {
                handleClickDelete();
              }}
            />
          </Row>
        </ButtonGroupWrapper>
      </InnerSection>
    </div>
  );
};

const ButtonGroupWrapper = styled.div``;

export default NewLandmarkModal;
